import {SideBar as SportcastSideBar} from '@sportcast/ui-react';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {useNavigationContext} from './NavigationContext';
import './SideBar.scss';

const SideBar = () => {
    const sessionStorageKey = 'sideBarCollapsed';

    const [isCollapsed, setIsCollapsed] = useState(window.sessionStorage.getItem(sessionStorageKey) === 'true');
    const loggedIn = useSelector((state: RootState) => state.login.loggedIn);
    const userIsActive = useSelector((state: RootState) => !!state.login.userData?.active);

    const {
        navigationItems,
        bottomNavigationItems,
        goHome
    } = useNavigationContext();

    useEffect(() => {
        if (window.sessionStorage.getItem(sessionStorageKey) === null) {
            setIsCollapsed(true);
            window.sessionStorage.setItem(sessionStorageKey, 'true');
        }
    }, []);

    if (!loggedIn) {
        return null;
    }

    const toggle = () => {
        setIsCollapsed(!isCollapsed);
        window.sessionStorage.setItem(sessionStorageKey, `${!isCollapsed}`);
    };
    
    const pagesWithoutSideBar = ['help', 'contact'];
    if (pagesWithoutSideBar.some(page => window.location.pathname.includes(page))) {
        return null;
    }

    return (
        <SportcastSideBar
            projectTitle="RePort"
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            navigationItems={loggedIn ? navigationItems as any : []}
            bottomNavigationItems={userIsActive ? bottomNavigationItems : []}
            isCollapsed={isCollapsed}
            onToggle={toggle}
            onLogoClick={goHome}
        />
    );
};

export default SideBar;
